import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppTheme } from '@theme';
import { isAndroid } from '@utils/util';
import { isMobile } from 'mobile-device-detect';

const androidMobileConstraints = {
    audio: false,
    video: {
        facingMode: 'user',
    },
};

const iOSMobileConstraints = {
    audio: false,
    video: {
        facingMode: 'user',
        width: {
            ideal: 768,
            min: 640,
        },
        height: {
            ideal: 1024,
            min: 480,
        },
    },
};

const desktopConstraints = {
    audio: false,
    video: {
        facingMode: 'user',
        width: {
            ideal: 1152,
            min: 640,
        },
        height: {
            ideal: 864,
            min: 480,
        },
    },
};

export const useCameraConstraints = () => {
    const theme = useAppTheme();
    const matchesMobileSm = useMediaQuery(`(max-width:${theme.breakPoints.sm})`);

    const [cameraConstraints] = useState(() => {
        if (matchesMobileSm || isMobile) {
            if (isAndroid()) {
                return androidMobileConstraints;
            }

            return iOSMobileConstraints;
        }

        return desktopConstraints;
    });

    return { cameraConstraints };
};
